<div class="wrapper">
  @for (order of activeOrders(); track order.orderID) {
    <app-order-card (click)="goToOrder(order)" [order]="order" mode="regular"></app-order-card>
  }
</div>